import BaseModelAPI from '../BaseModelAPI';

export default class UomList extends BaseModelAPI {

	static entity = 'uomlist'
	static entityName = 'uom';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
